export default {
    index() {
        return axios.get('/frontend/country')
    }
}
